/* istanbul ignore file */
import { Injectable } from '@angular/core';

import { CountryCode, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/mobile/examples';

@Injectable({
  providedIn: 'root',
})
export class LibPhonenumberService {
  getExampleNumber(countryCode: CountryCode) {
    return getExampleNumber(countryCode, examples);
  }
}
